// Customizer const

export const SWITCH_LANGUAGE = 'switch-language';
